import { Color, Flex, Icon, Spacing, Text, Tooltip } from '@billy/design-system'

interface TaxRateFieldProps {
  description?: string
  name?: string
  rate: number
}

export const TaxRateField = ({ rate, name, description }: TaxRateFieldProps) => {
  if (!name || !description) {
    return <Text alignment="right">{rate}</Text>
  }

  return (
    <Tooltip
      label={
        <Flex flexDirection="column" alignItems="center">
          <Text weight="semiBold" color={Color.White}>
            {name}
          </Text>
          <Text color={Color.White}>{description}</Text>
        </Flex>
      }
      placement="bottom"
    >
      <Flex alignItems="center" justifyContent="flex-end" gap={Spacing.S6}>
        <Text alignment="right">{rate}</Text>
        <Icon icon="info" color={Color.Black} />
      </Flex>
    </Tooltip>
  )
}
